<template>
  <b-container v-bind:class="{ 'mt-0' : isFanView}">
    <Headline title="Albums" v-if="!isFanView"></Headline>
    <ObjectListTabs v-if="!isFanView">
      <template slot-scope="{}">
        <b-nav-item :to="{name: 'artist-album-list', params: { visibility: 'public'}}">Albums</b-nav-item>
        <b-nav-item :to="{name: 'artist-album-list', params: { visibility: 'draft'}}">Drafts</b-nav-item>
      </template>
      <template slot="cmd" slot-scope="{}">
        <b-button class="btn-rainbow" :to="{name: 'artist-album-create'}" size="sm">
          <font-awesome-icon icon="plus"/> create album
        </b-button>
      </template>
      <template slot="mobileCmd" slot-scope="{}">
        <b-nav-item :to="{name: 'artist-album-create'}"><font-awesome-icon icon="plus"/> create album</b-nav-item>
      </template>
    </ObjectListTabs>

    <ProfileHero :artist="artist" v-if="isFanView && artist" />
    <ArtistProfileTabs :artist="artist" v-if="isFanView && artist" />

    <b-row v-for="album in albums" :key="album.id" align-v="center">
      <b-col class="col-12 col-lg-9 thumb py-2">
        <AlbumCard :album="album" :showArtist="isFanView" />
      </b-col>
      <b-col class="fan-actions col col-12 col-lg-3 pb-4 pb-lg-0 text-right" v-if="isFanView && album.songs.length">
        <Pay :album="album" v-if="isFanView"></Pay>
        <b-button variant="secondary" class="play-album" :to="{name: 'album-detail', params: {id: album.id}}" v-if="isFanView">
          <font-awesome-icon icon="play"/><span class="label"> &nbsp; play</span>
        </b-button>
      </b-col>
      <b-col cols="3" class="actions text-right" v-if="!isFanView">
        <b-button style="btn-secondary" :to="{name: 'artist-album-edit', params: { id: album.id } }" size="sm">
          <font-awesome-icon icon="pencil-alt" /> &nbsp; edit
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .container {
    margin-top: 1em;
  }
  .thumb img {
    width: 185px;
    height: 185px;
    object-fit: cover;
  }

  .info {
    .publish-date {
      color: $steel;
    }
    .title {
      font-weight: bold;
    }
    .songs {
      color: $steel;
    }
  }

  .actions button {
    padding-left: 2em;
    padding-right: 2em;
  }

  .play-album {
    padding-left: 2.7em;
    padding-right: 2.7em;
    margin-top: 0.5em;

    @include media-breakpoint-down(sm) {
      padding-left: 1.1em;
      padding-right: 1.1em;
      .label {
        display: none;
      }
    }
  }

  .fan-actions {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    .play-album {
      margin-top: 0.5em;
    }

    @include media-breakpoint-down(md) {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 1em 0 1em 0;
      justify-content: flex-end;

      a {
        margin-left: 1em;
      }

      .play-album {
        margin-top: 0;
      }
    }
  }

</style>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

import ObjectListTabs from '@/components/widgets/ObjectListTabs'
import AlbumCard from '@/components/widgets/AlbumCard'
import Pay from '@/components/widgets/Pay'
import ArtistProfileTabs from '@/components/widgets/ArtistProfileTabs'
import ProfileHero from '@/components/widgets/ProfileHero'
import Headline from '@/components/widgets/Headline'

export default {
  name: 'AlbumList',
  components: {
    FontAwesomeIcon,
    ObjectListTabs,
    AlbumCard,
    Pay,
    ArtistProfileTabs,
    ProfileHero,
    Headline
  },
  data () {
    return {
      artist: null,
      albums: []
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    isFanView () {
      return !!this.$route.params.artistId
    }
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    async fetchData () {
      if (this.isFanView) {
        this.artist = await this.$store.dispatch('artist/getArtist', { id: this.$route.params.artistId })
      } else {
        this.artist = this.$store.getters['artist/artist']
        if (!this.artist || !this.artist.id) {
          this.$router.push({name: 'fan-home'})
          return
        }
      }

      let response = await this.$store.dispatch('song/listAlbums', {
        artist_id: this.artist.id,
        visibility: this.$route.params.visibility
      })
      this.albums = await response.all()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/artist/AlbumList.vue